import { ReactElement } from 'react';
import styles from './Circle.module.scss';

interface CircleProps {
  children: JSX.Element;
  start?: boolean;
  end?: boolean;
  hideFirstLine?: boolean;
  hideLastLine?: boolean;
}

const Circle = ({
  children,
  start,
  end,
  hideFirstLine,
  hideLastLine,
}: CircleProps): ReactElement => {
  return (
    <div className={styles.iconCircleContainer}>
      <div className={`${styles.line} ${hideFirstLine ? styles.hidden : ''}`} />
      <div className={`${styles.iconCircle} ${start ? styles.start : end && styles.end}`}>
        {children}
      </div>
      <div className={`${styles.line} ${hideLastLine ? styles.hidden : ''}`} />
    </div>
  );
};

export default Circle;
